/** @jsx jsx */
import { useState } from 'react'
import { css, jsx, keyframes } from '@emotion/core'
import { Modal, Button, CheckboxField } from '@livechat/design-system'

import messageBoxIconImg from '../assets/images/message-box-icon.png'
import messageBoxSurveyImg from '../assets/images/message-box-survey.png'
import surveyCardImg from '../assets/images/survey-card.png'
import feedbackImg from '../assets/images/feedback.png'

import { checkLocalStorage } from '../utils'

const showModalAnimation = keyframes`
from {
 transform: translateY(20px);
}
`

const Hint = ({ setIsOpen }) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Modal
      onClose={() => {
        if (isChecked && checkLocalStorage()) {
          localStorage.setItem('dontShowHint', true)
        }
        setIsOpen(false)
      }}
      css={css`
        width: 700px;
        height: 582px;
        animation: ${showModalAnimation} 0.4s ease;
      `}
      heading="Good job! You created a new survey"
      footer={
        <div
          css={css`
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
          `}
        >
          <CheckboxField
            checked={isChecked}
            onClick={() => setIsChecked(!isChecked)}
            id="hint-checkbox"
          >
            Don't show again
          </CheckboxField>
          <Button
            primary
            className="show-results"
            onClick={() => {
              if (isChecked && checkLocalStorage()) {
                localStorage.setItem('dontShowHint', true)
              }
              setIsOpen(false)
            }}
            data-cy="surveys-hint-button"
          >
            Go on!
          </Button>
        </div>
      }
    >
      <div
        css={css`
          overflow-y: scroll;
          max-height: 410px;

          .img-container {
            width: 100%;
            display: flex;
            justify-content: center;
          }
        `}
      >
        <p
          css={css`
            margin-top: 0;
          `}
        >
          There are just a few steps left to send your survey to the customers.
        </p>
        <p>
          1. Make new survey <b>active</b>.
        </p>
        <div className="img-container">
          <img
            src={surveyCardImg}
            alt=""
            css={css`
              width: 35%;
            `}
          />
        </div>
        <p>
          2. Open <b>Surveys Panel</b> while chatting with customer.
        </p>
        <img
          src={messageBoxIconImg}
          alt=""
          css={css`
            width: 100%;
          `}
        />
        <p>
          3. <b>Pick the right survey</b> and send it to the customer via chat.
        </p>
        <img
          src={messageBoxSurveyImg}
          alt=""
          css={css`
            width: 100%;
          `}
        />
        <p>
          4. To monitore results, check please <b>Feedback section</b> in
          Surveys.
        </p>
        <img
          src={feedbackImg}
          alt=""
          css={css`
            width: 100%;
          `}
        />
      </div>
    </Modal>
  )
}

export default Hint
